import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdVehicleTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import vehicleIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-vehicle-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdVehicleContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 2000, // Reduced delay
    forceShowInPDF: true,
  });

  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-energy-contents">
      <SubHeaderBox
        subTitle={t("PRODUCTION_VEHICLES")}
        isNormal={true}
        number={"12.2D"}
        icon={vehicleIcon}
      />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-vehicle-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdVehicleTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdVehicleContents;
